const designTokens = {
  background: 'hsl(0, 0%, 100%)', // White
  foreground: 'hsl(184, 42%, 14%)', // Obsidian petrol
  card: 'hsl(0, 0%, 100%)', // White
  cardForeground: 'hsl(184, 42%, 14%)', // Obsidian petrol
  popover: 'hsl(0, 0%, 100%)', // White
  popoverForeground: 'hsl(184, 42%, 14%)', // Obsidian petrol
  primary: 'hsl(184, 42%, 14%)', // Obsidian petrol
  primaryForeground: 'hsl(0, 0%, 100%)', // White
  secondary: 'hsl(185, 24%, 30%)', // Ashen sage
  secondaryForeground: 'hsl(34, 30%, 86%)', // Pale nomad
  muted: 'hsl(227, 100%, 95%)', // Silken mauve
  mutedForeground: 'hsl(227, 60%, 70%)', // Silken mauve
  tertiary: 'hsl(34, 20%, 60%)', // Pale nomad but darker
  tertiaryForeground: 'hsl(34, 30%, 86%)', // Pale nomad
  accent: 'hsl(4, 89%, 62%)', // Carmine flame
  accentForeground: 'hsl(0, 0%, 100%)', // White
  border: 'hsl(227, 30%, 87%)', // Silken mauve
  input: 'hsl(227, 100%, 95%)', // Silken mauve
  ring: 'hsl(184, 42%, 14%)', // Obsidian petrol
  highlight: 'hsl(185, 22%, 41%)', // Lighter Ashen Sage
  success: 'hsl(170, 60%, 40%)', // Success green
  successForeground: 'hsl(0, 0%, 100%)', // White
  warning: 'hsl(36, 100%, 50%)', // Warning yellow
  warningForeground: 'hsl(0, 0%, 100%)', // White
  destructive: 'hsl(0, 60%, 40%)', // Error red (distinct from carmine flame)
  destructiveForeground: 'hsl(0, 90%, 90%)',
}

export default designTokens
